import { render } from "./DatesList.vue?vue&type=template&id=6a7bebda&scoped=true"
import script from "./DatesList.vue?vue&type=script&lang=js"
export * from "./DatesList.vue?vue&type=script&lang=js"

import "./DatesList.vue?vue&type=style&index=0&id=6a7bebda&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a7bebda"]])

export default __exports__